import Api from "@/services/Api";

export default {
  async activity(payload = {}) {
    const res = await Api(true).post("audit/activity", payload);
    return res.data;
  },

  async forSubject(payload = {}) {
    const res = await Api(true).post("audit/activity/for-subject", payload);
    return res.data;
  },

  async exportForSubject(payload = {}) {
    const res = await Api(true).post("audit/activity/for-subject/export", payload, { responseType: "blob" });
    const contentType = res?.headers?.["content-type"] || "";
    if (contentType.includes("application/json")) {
      const text = await res.data.text();
      const parsed = JSON.parse(text);
      throw new Error(parsed?.message || "Nuk u shkarkua eksporti i historikut.");
    }
    this.saveBlobDownload(res, `historik_produkt_${payload.subject_id || "produkt"}.xls`);
    return true;
  },

  saveBlobDownload(res, fallbackName) {
    let filename = fallbackName;
    const disposition = res?.headers?.["content-disposition"] || "";
    const match = disposition.match(/filename="?([^";]+)"?/i);
    if (match && match[1]) filename = match[1];

    let mime = res?.headers?.["content-type"] || "";
    if (mime.includes(";")) {
      mime = mime.split(";")[0].trim();
    }

    const blob = mime ? new Blob([res.data], { type: mime }) : new Blob([res.data]);
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  },

  async errors(payload = {}) {
    const res = await Api(true).post("audit/errors", payload);
    return res.data;
  },
};
